module.exports = __webpack_public_path__ + "media/images/bg/shapes/semester-course-dd29ca32b6641bbad69ebb45e40d5dc3.svg";